// extracted by mini-css-extract-plugin
export default {"price":"r7-z","onSale":"s7-z","msrpLabelPrice":"t7-z","msrpLabel":"u7-z","originalPrice":"v7-z","percentOff":"w7-z"};